import { parseFromWebStream } from "@discoveryjs/json-ext";

/**
 * Reads a JSON body without ever materialising it as one string, to avoid the browser's
 * 512M-character limit for a string.
 */
export const parseJsonStream = async <T>(response: Response): Promise<T> => {
  const body = response.body;

  // fetch polyfills and some test doubles expose no stream
  if (!body) return (await response.json()) as T;

  return (await parseFromWebStream(body)) as T;
};
